import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

import { SessionService } from "../../common/services/session.service";
import { SharedService } from "../../shared/service/api/shared.service";
import { SubjectService } from "./../../common/services/subject.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  providers: [SharedService],
})
export class MenuComponent implements OnInit {
  MenuItem = [];
  mobileMenuItem = [];
  userInfo: any;
  isVirtualView = false;
  userRole: any;
  permission: any;
  @Output() MenuToggler = new EventEmitter();
  langObj = {
    MCall: "Call",
    MComplaints: "Complaints",
    MConnector: "Connector",
    MDashboard: "Dashboard",
    MDevelopmentWork: "Development Work",
    MMeeting: "Meeting",
    MImportVoterData: "Import Voter Data",
    MKaryakarta: "Karyakarta",
    MMLAFund: "MLA Fund",
    MManageViewer: "Manage Viewer",
    MOffice: "Office",
    MOfficer: "Officer",
    MPublicEnquiry: "Public Enquiry",
    MMessagePannel: "Message Pannel",
    MRegister: "Register",
    MSchedule: "Schedule",
    MSuperAdminCreate: "Super Admin Create",
    MVisitors: "Visitors",
    MVoterSearch: "Voter Search",
    MUserMgmt: "User Management",
    MUserMgmts: "User Management",
    mVoterSearch:"Vote Search",
    MDaura: "Tour",
    MRepository: "Repository",
    MReport: "Report",
    MAdvertisement: "Advertisement",
    MKiosk: "Kiosk",
    EMail: "E-mail"
  };

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private subSession: SubjectService,
    public translate: TranslateService,
    private sharedService: SharedService,
    private ss: SessionService
  ) {
    this.userInfo = this.sessionService.getUserInfo();
    this.userRole = this.userInfo.role;
    this.subSession.selectedLang.subscribe((res: any) => {
      this.translate.get("Menulist").subscribe((data: any) => {
        this.langObj = data;
        this.permission = this.ss.getAuthPermission();
        this.setMenus();
      });
    });
  }

  toggleSideBar() {
    if (window.outerWidth < 897) {
      this.MenuToggler.emit("mobile");
    }
    this.MenuToggler.emit("web");
  }

  menuClickHandle(menu) {
    if (this.isVirtualView) {
      let vv = this.sessionService.getSessionVirtualViewId();
      if (vv.id === "ALL" && menu.label === "Dashboard") {
        this.router.navigate(["/viewer-dashboard"]);
        return;
      }
    }

    if (
      menu.label === "Dashboard" &&
      this.userInfo &&
      this.userInfo.role === "KARYA_KARTA"
    ) {
      this.router.navigate(["/karyakarta/dashboard"]);
      return;
    }
    if (
      menu.label === "Dashboard" &&
      this.userInfo &&
      this.userInfo.role === "VIEWER"
    ) {
      this.router.navigate(["/viewer-dashboard"]);
      return;
    }

    this.router.navigate([menu.link]);
  }

  setMenus() {
    let sideMenu = {
      DEVELOPMENT_WORK: {
        key: "VIKASKAME",
        label: this.langObj.MDevelopmentWork,
        icon: "pi pi-pw pi-chart-bar",
        link: "/vikas-kame/list",
        rank: 1,
      },
      MLA_FUND_MGMT: {
        key: "MLA_FUND_MGMT",
        label: this.langObj.MMLAFund,
        icon: "fa fa-fw fa-inr",
        link: "/mla-fund-mgmt/list",
        rank: 2,
      },
      OFFICE: {
        key: "OFFICE",
        label: this.langObj.MOffice,
        icon: "pi pi-pw pi-briefcase",
        link: "/office/list",
        rank: 3,
      },
      OFFICER: {
        key: "OFFICER",
        label: this.langObj.MOfficer,
        icon: "pi pi-pw pi-user-plus",
        link: "/adhikari/list",
        rank: 4,
      },
      CONNECTOR: {
        key: "CONNECTOR",
        label: this.langObj.MConnector,
        icon: "pi pi-pw pi-user-minus",
        link: "/connector/list",
        rank: 5,
      },
      KARYAKARTA: {
        key: "KARYAKARTAS",
        label: this.langObj.MKaryakarta,
        icon: "pi pi-pw pi-user",
        link: "karyakarta/list",
        rank: 6,
      },
      DUARA: {
        key: "DUARA",
        label: this.langObj.MDaura,
        icon: "pi pi-pw pi-calendar-plus",
        link: "duara/list",
        rank: 7,
      },
      REPOSITORY: {
        key: "REPOSITORY",
        label: this.langObj.MRepository,
        icon: "pi pi-pw pi-file",
        link: "/repository/list",
        rank: 8,
      },
      PUBLIC_ENQUIRY: {
        key: "PUBLIC_ENQUIRY",
        label: this.langObj.MPublicEnquiry,
        icon: "pi pi-pw pi-users",
        link: "/enquiry/container",
        rank: 9,
      },
      SUPERADMIN_CREATE: {
        key: "SUPERADMIN_CREATE",
        label: this.langObj.MSuperAdminCreate,
        icon: "pi pi-pw pi-user-plus",
        link: "/super-admin",
        rank: 10,
      },
      MANAGE_VIEWER: {
        key: "MANAGE_VIEWER",
        label: this.langObj.MManageViewer,
        icon: "pi pi-pw pi-eye",
        link: "/user/viewer/list",
        rank: 11,
      },
      MESSAGE_PANNEL: {
        key: "MESSAGE_PANNEL",
        label: this.langObj.MMessagePannel,
        icon: "pi pi-pw pi-envelope",
        link: "/message-pannel/send-message",
        rank: 12,
      },
      // IMPORT_VOTER_DATA: {
      //   key: "IMPORT_VOTER_DATA",
      //   label: this.langObj.MImportVoterData,
      //   icon: "pi pi-pw pi-upload",
      //   link: "/import-voter",
      //   rank: 13,
      // },
      // VOTER_SEARCH: {
      //   key: "VOTER_SEARCH",
      //   label: this.langObj.MVoterSearch,
      //   icon: "pi pi-pw pi-search",
      //   link: "/voter/search",
      //   rank: 14,
      // },
      REPORT: {
        key: "REPORT",
        label: this.langObj.MReport,
        icon: "pi pi-pw pi-file",
        link: "/report",
        rank: 15,
      },
      ADVERTISEMENT: {
        key: "ADVERTISEMENT",
        label: this.langObj.MAdvertisement,
        icon: "pi pi-pw pi-camera",
        link: "/advertisement/list",
        rank: 16,
      },
      KIOSK: {
        key: "KIOSK",
        label: this.langObj.MKiosk,
        icon: "pi pi-pw pi-money-bill",
        link: "/kiosk-list",
        rank: 17,
      },
      USER_MGMT: {
        key: "USER_MGMT",
        label: this.langObj.MUserMgmt,
        icon: "pi pi-pw pi-users",
        link: "/manage-user/user-mgmt-list",
        rank:18,
      },
      // VOTER_SEARCH_HISTORY:{
      //   key: "PUBLIC_SEARCH_HISTORY",
      //   label: "Public Search History",
      //   icon: "pi pi-pw pi-replay",
      //   link: "/public-search-history/history",
      //   rank: 19,
      // },
      VOTER_SEARCH: {
        key: "VOTER_SEARCH",
        label: "Voter Search",
        icon: "pi pi-pw pi-search",
        link: "/voter/search",
        rank:20,
      },
      DYNAMIC_FORM: {
        key: "DYNAMIC_FORM",
        label: "Dynamic Form",
        icon: "pi pi-pw pi-money-bill",
        link: "/donate/list",
        rank: 21,
      },
      EMAIL_MODULE: {
        key: "EMAIL_MODULE",
        label: "Email",
        icon: "pi pi-pw pi-envelope",
        link: "/email/list",
        rank: 30,
      },
      // MEETING: {
      //   key: "MEETING",
      //   label: "Meeting", 
      //   icon: "pi pi-pw pi-calendar",
      //   link: "/meeting/list",
      //   rank: 22, 
      // },
      
    };
    let systemSideMenu = [
      {
        key: "IMPORT_VOTER_DATA",
        label: this.langObj.MImportVoterData,
        icon: "pi pi-pw pi-upload",
        link: "/import-voter",
        rank: 1,
      },
      {
        key: "VOTER_SEARCH_CONFIG",
        label: "Voter Search Config",
        icon: "pi pi-pw pi-check-circle",
        link: "/voter-search-config",
        rank: 2,
      },

    {
        key: "PUBLIC_SEARCH_HISTORY",
        label: "Public Search History",
        icon: "pi pi-pw pi-replay",
        link: "/public-search-history/history",
        rank: 3,
      },
      
      {
        key: "USER_MGMT",
        label: this.langObj.MUserMgmt,
        icon: "pi pi-pw pi-users",
        link: "/manage-user/user-mgmt-list",
        rank: 4,
      },
    ];
    if (this.userRole == "SYSTEM_ADMIN") {
      this.MenuItem = systemSideMenu;
    } else {
      console.log('this.permissions: ', this.permission)
      this.permission.map((elePer) => {
        if (sideMenu[elePer.name]) {
          this.MenuItem.push(sideMenu[elePer.name]);
        }
      });
      // this.MenuItem.push(sideMenu['EMAIL_MODULE']);
      // this.MenuItem.push(sideMenu['MEETING']);
    }

    //sorting array rank wise
    this.MenuItem.sort(function (rank1, rank2) {
      return rank1.rank - rank2.rank;
    });
    return this.MenuItem;
  }

  ngOnInit() {
    this.userInfo = this.sessionService.getUserInfo();
    //this.permissions();
    this.isVirtualView = this.sessionService.isVirtualView();
  }

  toggleDropdown() {
    var dropdown = document.getElementsByClassName("dropdown-btn");
    var i;

    for (i = 0; i < dropdown.length; i++) {
      dropdown[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var dropdownContent = this.nextElementSibling;
        if (dropdownContent.style.display === "block") {
          dropdownContent.style.display = "none";
        } else {
          dropdownContent.style.display = "block";
        }
      });
    }
  }
}
